import { Workbook } from "exceljs";
import { EventActivityResponse } from "../../services/reports.service";
import {
	applyHeaderStyle,
	rateFillArgb,
	statusFillArgb,
} from "./workbook-styles";

const EVENT_ACTIVITY_DAYS = 14;

export const addEventActivitySheet = (
	workbook: Workbook,
	data: EventActivityResponse,
): void => {
	const sheet = workbook.addWorksheet("Event activity");

	const dayEventColumns: Array<{
		header: string;
		key: string;
		width: number;
	}> = [];
	for (let d = 1; d <= EVENT_ACTIVITY_DAYS; d++) {
		for (const ev of data.events) {
			dayEventColumns.push({
				header: `D${d} ${ev.name}`,
				key: `d${d}_${ev.eventId}`,
				width: 12,
			});
		}
	}

	sheet.columns = [
		{ header: "Participant", key: "participantName", width: 28 },
		{ header: "Org unit", key: "orgUnit", width: 22 },
		...dayEventColumns,
		{ header: "Completion %", key: "completionPct", width: 14 },
	];
	applyHeaderStyle(sheet.getRow(1));

	for (const row of data.rows) {
		const flatRow: Record<string, unknown> = {
			participantName: row.participantName,
			orgUnit: row.orgUnit,
			completionPct: row.completionPct,
		};
		for (const day of row.days) {
			for (const sub of day.submissions) {
				flatRow[`d${day.day}_${sub.eventId}`] = sub.status;
			}
		}
		const r = sheet.addRow(flatRow);

		for (let d = 1; d <= EVENT_ACTIVITY_DAYS; d++) {
			for (const ev of data.events) {
				const key = `d${d}_${ev.eventId}`;
				const value = flatRow[key] as string | undefined;
				if (!value) continue;
				const fill = statusFillArgb(value);
				if (fill) {
					r.getCell(key).fill = {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: fill },
					};
				}
			}
		}
		const rateFill = rateFillArgb(row.completionPct);
		if (rateFill) {
			r.getCell("completionPct").fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: rateFill },
			};
		}
		r.getCell("completionPct").numFmt = "0.0";
	}
};
